import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'

export const ItineraryWrapper = styled.div`
  height: 100%;

  ${mq.tabletLMax} {
    overflow: hidden;
  }
`

export const ItineraryHeading = styled.div`
  ${mq.tabletL} {
    position: sticky;
    top: 5rem;
  }
`

export const ItineraryListWrap = styled.div`
  margin-right: -5rem;
  overflow: hidden;
  position: relative;
`

export const ItineraryList = styled.ul`
  list-style-type: none;
  padding-right: 5rem;
`
